<template>
    <section class="bloco_com-fundo-branco u-margem-inferior-grande" tabindex="1">
        <div class="caixa_cor-cinza-claro u-padding-media ">
            <div class="grade__linha informacoes-primarias alinhamento-entre-colunas grade__linha_alinhar-vertical-centro">
                <div class="informacoes-primaria__icone">
                    <i class="fad fa-user-alt"></i>
                </div>
                <div class="u-margem-esquerda-pequena informacoes-primaria__texto">
                    <h3 class="titulo titulo_medio ">Olá {{ obterPrimeiroNome(dados.NomeDoBeneficiario)}}</h3>
                    <div class="informacoes-primarias__numero-do-contrato">
                        Seu número de contrato é <strong>{{ dados.NumeroDoContrato }}</strong>
                    </div>
                </div>
            </div>
        </div>
        <div class="informacoes-beneficiario u-padding-media">
            <div class="informacoes-beneficiario_nome">
                <h3 class="titulo titulo_mini">Nome completo:</h3>
                <p class="u-sem-margem">
                    {{ dados.NomeDoBeneficiario }}
                </p>
            </div>
            <div class="informacoes-beneficiario_endereco">
                <h3 class="titulo titulo_mini">CPF:</h3>
                <p class="u-sem-margem">
                    {{ formatarCpf(dados.Cpf) }}
                </p>
            </div>
            <div class="informacoes-beneficiario_endereco">
                <h3 class="titulo titulo_mini">Endereço do imóvel</h3>
                <p v-show="dados.Logradouro.length > 0" class="u-sem-margem">
                    {{ `${dados.Logradouro} ${dados.QuadraELote ? ', ' + dados.QuadraELote : ''} - BAIRRO ${dados.Bairro} - ${dados.Cep} - ${dados.CidadeComEstado}`}}
                </p>
            </div>

        </div>
    </section>
</template>
<script>
    import {formatacaoDeValores} from '../../mixins/formatacaoDeValoresMixin.js';

    export default {
        name: 'cabecalho',
        props: [
            'dados'
        ],
        mixins: [
            formatacaoDeValores,
        ],
        methods: {
            obterPrimeiroNome(nome) {
                return nome ? nome.split(' ')[0] : '';
            }
        }
    }

</script>
